<section class="quote-final" aria-label="Quote">
  <h3 class="quote-final__heading">QUOTE</h3>

  <article class="quote-final__card">
    <span class="quote-final__vendor">{{
      estimate().name ?? "Unknown Vendor"
    }}</span>

    @if (finalHasAnyReclassification()) {
      <div
        class="quote-final__reclassification-banner"
        role="alert"
        data-testid="job-requirement-change-banner"
      >
        <mat-icon class="quote-final__banner-icon" aria-hidden="true"
          >info</mat-icon
        >
        <p class="quote-final__banner-text">
          <strong>Job Requirement Change:</strong> While reviewing your files
          for translation, the vendor identified some changes regarding Desktop
          Publishing needs. If you select this quote, these changes will be
          reflected in the Job Details tab. For more details please expand the
          Document Requirement Changes accordion.
        </p>
      </div>
    }

    <!-- Info row -->
    <div class="quote-final__info">
      <div class="quote-final__info-col">
        <span class="quote-final__info-label">Delivery type</span>
        <span class="quote-final__info-value">{{
          selectedDeliveryType()
        }}</span>
      </div>
      <div class="quote-final__info-col">
        <span class="quote-final__info-label">Delivery date</span>
        <span class="quote-final__info-value">{{
          selectedDeliveryDate()
        }}</span>
      </div>
      <div class="quote-final__info-col">
        <span class="quote-final__info-label">Quote ID</span>
        <span class="quote-final__info-value">{{ selectedQuoteId() }}</span>
      </div>
    </div>

    <!-- Cost breakdown -->
    @if (selectedCostBreakdown().length) {
      <div class="quote-final__breakdown">
        @for (item of selectedCostBreakdown(); track item.concept) {
          <div class="quote-final__breakdown-row">
            <span class="quote-final__breakdown-concept">{{
              item.concept
            }}</span>
            <span class="quote-final__breakdown-cost">{{
              item.cost | formatCurrency: selectedCurrency()
            }}</span>
          </div>
        }
      </div>
    }

    <!-- Total cost -->
    <div class="quote-final__total">
      <span class="quote-final__total-label">Total cost</span>
      <span class="quote-final__total-value">{{
        selectedTotalCost() | formatCurrency: selectedCurrency()
      }}</span>
    </div>

    <!-- PO number -->
    @if (order().vendorPrice) {
      <div class="quote-final__po">
        <span class="quote-final__po-label">Purchase Order ID</span>
        <span class="quote-final__po-value">{{ order().vendorPrice }}</span>
      </div>
    }
  </article>
</section>

<!-- ── Previous Quotes (collapsible accordion) ───────────────────── -->
<app-document-requirement-changes [detail]="finalVendorJobDetails()" />

<app-previous-quotes
  [estimates]="finalApprovedPreviousEstimates()"
  [order]="order()!"
  [lowestCostId]="finalApprovedLowestCostId()"
/>
